import RallySSO from "./rallySSO";
import {get} from "lodash";
import {IS_SSO_BACKDOOR, SSO_PREFIX} from "data/constants";
import {loadScriptPromise} from "data/utils/index";

export enum SSOErrors {
	Under21 = "under_21",
	NoDate = "no_date",
}

export enum SSOType {
	Rally = "rally",
	Web = "web",
}

export interface ISSOPayload {
	platform: string;
	uid: string;
}

export interface ISSOPayloadWithDisplayName extends ISSOPayload {
	displayName?: string;
}

interface IMlbOktaError {
	redirect: boolean;
	message: {
		errorCode: "login_required" | string;
		errorSummary: string;
		name: string;
	};
}

export const deeplinkOrWebRedirect = (href: string, _timeout = 1000) => {
	window.location.href = href;
};

const authError = "Authorization failed";

export class SSO {
	static IS_BACKDOOR_MODE = IS_SSO_BACKDOOR;
	private static BASE_DOMAIN = process.env.REACT_APP_BASE_DOMAIN || "";
	private static BASE_URL = process.env.REACT_APP_BASE_URL || "";
	private uuid: string = "";
	private platform: string = "web";
	private type: SSOType = SSOType.Web;
	private error: SSOErrors | null = null;

	public async initRallySSO() {
		const mlbApi = new RallySSO();

		await mlbApi.init();

		await new Promise((resolve) => {
			void mlbApi.initialize(() => {
				const user = mlbApi.getUser();
				const oktaId = get(user, "oktaId", undefined);

				if (oktaId) {
					this.uuid = oktaId;
					this.type = SSOType.Rally;
				} else {
					mlbApi.showAlert(authError);
					throw new Error(`${authError}: ${JSON.stringify(user)}`);
				}
				resolve(null);
			});
		});
	}

	public async initWebAuthSSO() {
		const scriptUrl = `https://${SSO_PREFIX}mlbstatic.com/mlb.com/vendor/mlb-okta/mlb-okta.js`;
		await loadScriptPromise(scriptUrl);

		try {
			if (!window.mlbOkta) {
				throw new Error("No mlb api found");
			}

			const result = await window.mlbOkta.isLoggedIn();
			const accessToken = get(result, "accessToken");
			const claims = get(accessToken, "claims");
			const uid = get(claims, "uid", "");

			if (!uid) {
				throw new Error("No credentials");
			}

			// const checkAgeState = this.checkUnder21();
			//
			// if (checkAgeState) {
			// 	this.error = checkAgeState;
			// }

			// this.token = token;
			this.uuid = uid;
			this.type = SSOType.Web;
		} catch (e: unknown) {
			const error = e as IMlbOktaError;

			if (!error.redirect) {
				const errorMessage = get(error, "message");
				const message = get(errorMessage, "errorSummary", authError);
				throw new Error(message);
			}

			// window.mlbOkta.redirectToLogin();
			SSO.TO_PLAY_LOGIN_FORM();
			throw new Error(authError);
		}
	}

	public static TO_MLB = () => {
		window.location.href = "https://www.mlb.com";
	};

	public static TO_PLAY_LOGIN_FORM = () => {
		deeplinkOrWebRedirect(
			`${SSO.BASE_DOMAIN}/login?redirectUri=${SSO.BASE_DOMAIN}${SSO.BASE_URL}/`
		);
	};

	public static TO_UPDATE_FORM = () => {
		if (RallySSO.IS_NATIVE) {
			return;
		}
		window.location.href = `${SSO.BASE_DOMAIN}/play?redirectUrl=${SSO.BASE_DOMAIN}${SSO.BASE_URL}?&gameId=Spinball2024`;
	};

	public static TO_LOGIN_ON_BOARDING = () => {
		window.location.href = `${SSO.BASE_DOMAIN}/play/onboarding?step=updateAccount`;
	};

	public toJSON(): ISSOPayload {
		return {
			platform: this.platform,
			uid: this.uuid,
		};
	}

	public static keepBackdoorSession() {
		sessionStorage.setItem("backdoor", "true");
	}

	public static getIsSessionBackdoor() {
		return Boolean(sessionStorage.getItem("backdoor"));
	}
}
